import { z } from 'zod';

/** Body of `GET /healthz` and `GET /readyz` when the API is up (standards §6). */
export const HealthResponseSchema = z.strictObject({ status: z.literal('ok') });

/** A parsed health body; see {@link HealthResponseSchema}. */
export type HealthResponse = z.infer<typeof HealthResponseSchema>;
